/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import SimplifiedHeader from '../components/SimplifiedHeader';
import { useParams } from 'react-router-dom';
import BackToStorefront from '../components/BackToStorefront';
import purchaseService from '../services/purchaseService';
import ReceiptCard from '../components/ReceiptCard';
import DownloadIcon from '/asset/download.svg';
import LoadingGif from '/asset/loading.gif';
import CancelIcon from '/asset/cancel.svg';

const Logo = localStorage.getItem('coverImage');

const InvoicePDF = () => {
  const { purchaseCode } = useParams();
  const receiptRef = useRef<HTMLDivElement | null>(null);
  const handleDownloadPDF = async () => {
    const element = receiptRef.current;
    if (!element) return;
    const canvas = await html2canvas(element, { scale: 2, useCORS: true });
    const imgData = canvas.toDataURL('image/png');
    const imgWidth = 210;
    const pxPerMm = canvas.width / imgWidth;
    const imgHeight = canvas.height / pxPerMm;
    const pdf = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: [imgWidth, imgHeight],
    });
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    pdf.save('receipt.pdf');
  };

  const [orderDetails, setOrderDetails] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);

  const getOrderDetails = async () => {
    setLoading(true);
    if (purchaseCode) {
      await purchaseService
        .getSingleOrderByPurchaseCode(purchaseCode)
        .then((res) => {
          if (res.purchaseCode) setOrderDetails(res);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          setOrderDetails(null);
        });
    }
  };

  useEffect(() => {
    if (purchaseCode) getOrderDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseCode]);

  return (
    <div className="min-h-screen bg-gray-100">
      <SimplifiedHeader />

      {orderDetails && orderDetails?.purchaseCode && (
        <div className="px-4 py-6">
          {/* Download button */}
          <div
            className="max-w-[480px] mx-auto flex 
          justify-end mb-3"
          >
            <button
              onClick={handleDownloadPDF}
              className="flex items-center gap-1.5 
              text-white hover:text-white
              hover:border-secondary-300
              hover:bg-secondary-700
              font-dmsans text-sm bg-secondary-500 
              shadow-sm"
            >
              <img
                src={DownloadIcon}
                className="w-4 h-4 object-contain"
                alt=""
              />
              Download as PDF
            </button>
          </div>

          {/* Invoice card */}
          <ReceiptCard ref={receiptRef} orderDetails={orderDetails} />

          {/* Back to storefront */}
          <div className="max-w-[480px] mx-auto mt-4">
            <BackToStorefront
              variant="link"
              text="Back to storefront"
              navigateTo={``}
            />
          </div>
        </div>
      )}

      {loading && (
        <div className="flex flex-col items-center justify-center pt-20">
          <img src={LoadingGif} className="w-10" alt="loading" />
          <p className="text-[11px] font-dmsans text-gray-500 mt-2">
            Getting receipt...
          </p>
        </div>
      )}

      {!loading && !orderDetails && (
        <div className="flex flex-col items-center justify-center pt-20">
          {Logo && (
            <img
              src={Logo}
              className="w-24 h-24 object-contain mb-4"
              alt="logo"
            />
          )}
          <img src={CancelIcon} className="mb-3" alt="not found" />
          <h2 className="text-[15px] font-semibold font-dmsans text-gray-800">
            Order Not Found
          </h2>
        </div>
      )}
    </div>
  );
};

export default InvoicePDF;
